const itemFormDefaults = {
  year: '',
  month: '',
  day: '',
  time: '',
  dateDisplay: '',
  layout: '',
  headline: '',
  linkUrl: '',
  description: '',
  media: '',
  mediaSource: 'url',
  mediaUrl: '',
  mediaDescription: '',
  mediaCredit: '',
  mediaDescriptionInherit: true,
  mediaCreditInherit: true,
  mediaLinkUrl: '',
  mediaBackgroundVideo: false,
  mediaLoop: true,
  location: '',
  locationInherit: false,
  structuredContent: [],
  tags: [],
};

export default itemFormDefaults;
